import {getWorkspaceFromUri, urlBuilder, UrlBuilderConfig} from '@dms/routes';

export function getDigitalCertificateUrl(inspectionId: string, locale: string) {
  const {workspace} = getWorkspaceFromUri();

  const builderConfig: UrlBuilderConfig = {
    workspace,
    protocol: window.location.protocol,
    domain: process.env.DIGITAL_CERTIFICATE_DOMAIN!,
    route: `/${inspectionId}`,
    searchParam: `?lang=${locale}`,
  };

  return urlBuilder(builderConfig);
}
